export default __webpack_public_path__ + "static/media/search-icon.77247a3d.svg";